export const VIDEO_LOCATIONS = {
  carousel: 'Carousel',
  heroVideo: 'Hero Video',
};
